export const COUNTRIES: Country = {
  au: {
    name: 'Australia',
    value: 'au',
    currency: 'AUD',
    currencyLabel: 'Australian Dollar',
    language: 'English'
  },
  nz: {
    name: 'New Zealand',
    value: 'nz',
    currency: 'NZD',
    currencyLabel: 'New Zealand Dollar',
    language: 'English'
  }
};

export interface Country {
  [ key: string ]: CountryData;
}

export interface CountryData {
  name: string;
  value: string;
  currency: string;
  currencyLabel: string;
  language: string;
}
